// @flow
export const MAP_LAYER_DRAWER_TOGGLE = 'mapLayerDrawer/TOGGLE';

export function toggleMapLayerDrawer(open) {
  return {
    type: MAP_LAYER_DRAWER_TOGGLE,
    open,
  };
}



// WEBPACK FOOTER //
// ./actions/mapLayerDrawer.js